import React, { useMemo } from 'react';
import { useUserContext } from '../../utils';

export default (WrappedComponent) => {
	const ReturnedComponent = (props) => {
		const { userSettings } = useUserContext();

		const {
			listId,
			initialSortBy: initialSortByFromProps,
			initialSortDirection: initialSortDirectionFromProps,
			initialPerPage: initialPerPageFromProps,
			initialPage: initialPageFromProps,
		} = props;

		const listSettingProps = useMemo(() => {
			let initialSortBy = initialSortByFromProps || 'created';
			let initialSortDirection = initialSortDirectionFromProps || -1;
			// commented out as it breaks i.e. SR creator, to be fixed and then introduced
			// let initialPerPage = initialPerPageFromProps || (userSettings?.performanceMode ? 10 : 100);
			let initialPerPage = initialPerPageFromProps || 100;

			const initialPage = initialPageFromProps || 0;

			if (userSettings && listId) {
				const sortByFromSettings = getListSetting('sortBy', userSettings, listId);
				const sortDirectionFromSettings = getListSetting('sortDirection', userSettings, listId);
				const perPageFromSettings = getListSetting('perPage', userSettings, listId);

				initialSortBy = sortByFromSettings === undefined ? initialSortBy : sortByFromSettings;
				initialSortDirection = sortDirectionFromSettings === undefined ? initialSortDirection : sortDirectionFromSettings;
				initialPerPage = perPageFromSettings === undefined ? initialPerPage : perPageFromSettings;
			}

			return {
				initialSortBy,
				initialSortDirection,
				initialPerPage,
				initialPage,
			};
		}, [initialPageFromProps, initialPerPageFromProps, initialSortByFromProps, initialSortDirectionFromProps, listId, userSettings]);

		return (
			// eslint-disable-next-line react/jsx-filename-extension
			<WrappedComponent
				{...props}
				{...listSettingProps}
			/>
		);
	};

	return ReturnedComponent;
};

const getListSetting = (setting, userSettings, listId) => {
	if (!userSettings || !listId || !userSettings.lists || !userSettings.lists[listId] || !userSettings.lists[listId][setting]) {
		// can be undefined
		return undefined;
	}

	return userSettings.lists[listId][setting];
};
